export default __webpack_public_path__ + "static/media/blank-user-img.2fda6558.png";